import { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import UserContext from 'context/UserSessionContext';

import useApi, { UPDATE_WIDGET_ATTRIBUTES } from 'hooks/useApi';
import * as DASHBOARD_ACTIONS from 'hooks/useFetchCannedDashboardList/actions';

import { mapWidgetType, updateNavigationDashboardsItem } from 'utils/widget-helpers';

export default ({ widget, dashboardData, dispatchCannedDashboardList }) => {
  const [hasDataChanged, setHasDataChanged] = useState(false);
  const history = useHistory();
  const { id } = useParams();

  const { session } = useContext(UserContext);
  const { portfolios, holdings } = session;

  const [state, sendRequest] = useApi();
  const { data: dashboardId, isLoading, isError } = state;

  const widgetType = widget && widget.overlay.baseWidget.widgetType.name;

  useEffect(() => {
    if (isLoading || isError || !dashboardId) {
      return;
    }

    const { masterObjectId, isCanned } = dashboardData;

    if (isCanned) {
      dispatchCannedDashboardList({
        type: DASHBOARD_ACTIONS.DASHBOARD_UPDATE_LIST_ITEM,
        payload: { currentDashboardId: id, deepCopyDashboardId: dashboardId }
      });

      updateNavigationDashboardsItem({ portfolios, holdings, masterObjectId, id, dashboardId });
      history.push(`/canned/${masterObjectId}/${dashboardId}`);
    } else {
      setHasDataChanged(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardId, isLoading, isError, dashboardData, history, dispatchCannedDashboardList]);

  const onAttributesUpdateSubmit = attributeIds => {
    const {
      masterObjectId: dashboardMasterObjectId,
      masterObjectTypeId: dashboardMasterObjectTypeId,
      objectTypeDetailId: dashboardObjectTypeDetailId
    } = dashboardData;

    const updateData = {
      id: widget.id,
      widgetType: mapWidgetType(widgetType),
      attributeIds,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId
    };

    sendRequest(UPDATE_WIDGET_ATTRIBUTES({ ...updateData }));
  };

  return [onAttributesUpdateSubmit, hasDataChanged, setHasDataChanged];
};
